module.exports = __webpack_public_path__ + "static/carpoolchella-cta-4-8a378bbfd251276cacaa3e39730ee7c3.jpg";